<template>
  <div class="PageSignin">
    <div class="card-wrap">
      <div class="avatar-wrap">
        <ChildAvatar />
      </div>
      <Card>
        <div class="card-inner">
          <p class="message">ご利用いただくには<br>ログインが必要です</p>
          <div class="cta">
            <UiButton :isLoading="isLoading" @click="signin('google')"><i class="fab fa-google"></i>Googleアカウントでログイン</UiButton>
          </div>
          <div class="cta" v-if="!isProd">
            <UiButton :isLoading="isLoading" @click="signin('anonymous')">開発者ログイン</UiButton>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import Card from '@/components/atoms/Card'
import ChildAvatar from '@/components/atoms/ChildAvatar'
import Container from '@/components/atoms/Container'
import UiButton from '@/components/atoms/UiButton'

import Auth from '@/firebase/auth'
const auth = new Auth()

export default {
  name: 'PageSignin',
  components: {
    Card,
    ChildAvatar,
    Container,
    UiButton,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    redirectTo() {
      return this.$route.query.redirect || '/children'
    },
    isProd() {
      return location.host === 'bublo.me'
    },
  },
  methods: {
    async signin(type) {
      try {
        this.isLoading = true
        let user
        if (type === 'google') {
          user = await auth.signinWithGoogle()
        } else {
          user = await auth.signin()
        }
        this.$notify('ログインしました')
        this.$router.push(this.redirectTo)
        console.log('signin! done', user)
      } catch(error) {
        this.$notify('失敗しました')
        this.isLoading = false
        console.error(error)
      }
    },
  },
}
</script>

<route-meta>
{
  "authFree": true
}
</route-meta>

<style scoped lang="scss">
.PageSignin {
  background: $background;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  max-width: 640px;
  margin: 0 auto;
}
.avatar-wrap {
  width: 90px;
  margin: 0 auto 25px;
}
.message {
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}
.cta {
  margin: 10px 0 0;

  i {
    margin-right: 0.5em;
  }
}
.card-wrap {
  flex: 1;
}
.card-inner {
  padding: 20px;
}
</style>
